import { ComponentStyle, DiyComponent } from '@/components/DiyEditor/util'
import { cloneDeep } from 'lodash-es'

/** 营销三入口属性 */
export interface ActivityEntryProperty {
  // 入口列表（建议 3 个）
  list: ActivityEntryItemProperty[]
  // 组件样式
  style: ComponentStyle
}

export interface ActivityEntryItemProperty {
  // 图标
  iconUrl: string
  // 标题
  title: string
  // 标题颜色
  titleColor: string
  // 副标题
  subtitle: string
  // 副标题颜色
  subtitleColor: string
  // 跳转链接
  url: string
}

export const EMPTY_ACTIVITY_ENTRY_ITEM = {
  iconUrl: '',
  title: '标题',
  titleColor: '#1a1a1a',
  subtitle: '副标题',
  subtitleColor: '#8c8c8c',
  url: ''
} as ActivityEntryItemProperty

const defaultItems: ActivityEntryItemProperty[] = [
  {
    iconUrl: '',
    title: '限时秒杀',
    titleColor: '#1a1a1a',
    subtitle: '低价抢购',
    subtitleColor: '#8c8c8c',
    url: '/pages/modules/mall/activity/seckill/list'
  },
  {
    iconUrl: '',
    title: '拼团优选',
    titleColor: '#1a1a1a',
    subtitle: '一起更省',
    subtitleColor: '#8c8c8c',
    url: '/pages/modules/mall/activity/groupon/list'
  },
  {
    iconUrl: '',
    title: '积分商城',
    titleColor: '#1a1a1a',
    subtitle: '积分兑换',
    subtitleColor: '#8c8c8c',
    url: '/pages/modules/mall/activity/point/list'
  }
]

// 定义组件
export const component = {
  id: 'ActivityEntry',
  name: '营销三入口',
  icon: 'ep:grid',
  property: {
    list: cloneDeep(defaultItems),
    style: {
      bgType: 'color',
      bgColor: '#fff',
      marginBottom: 8,
      marginLeft: 8,
      marginRight: 8,
      paddingTop: 8,
      paddingRight: 8,
      paddingBottom: 8,
      paddingLeft: 8,
      borderRadius: 10,
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      borderBottomRightRadius: 10,
      borderBottomLeftRadius: 10
    } as ComponentStyle
  }
} as DiyComponent<ActivityEntryProperty>
